module.exports = __webpack_public_path__ + "img/vertical_6_6_6005.b41cae35.png";